import React from "react";
import {
  Input,
  Select,
  Space,
  Button,
  Col,
  Row,
  message,
  Tooltip,
  Tag,
  Modal,
  Image,
  Drawer,
  Dropdown,
} from "antd";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import BookingAdd from "./BookingAdd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import BookingStore from "../store/BookingStore";
import ListTable from "./ListTable";
import dayjs from "dayjs";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import { CloseCircleOutlined } from "@ant-design/icons";
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length >= 18) {
      val.width = 180;
    } else if (val.title?.length > 15) {
      val.width = 160;
    } else if (val.title?.length > 12) {
      val.width = 130;
    } else if (val.title?.length > 8) {
      val.width = 115;
    } else {
      val.width = 105;
    }
    // console.log(val.title.length)
  });

  return arr;
};
class BookingList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    this.companyStore = new CompanyStore(this);
    this.bookingStore = new BookingStore(this);

    this.selectedCol = [
      {
        key: "18",
        title: context.translate("_BOOKING_REQUEST_ID_"),
        dataIndex: "bookingRequestId",
        fixed: "left",
        // render: (val, record) => {
        //   return (
        //     <Link
        //       onClick={(e) => {
        //         e.preventDefault();
        //         this.onEdit(record);
        //       }}
        //     >
        //       {val}
        //     </Link>
        //   );
        // },
      },
      {
        key: "1",
        title: context.translate("_TAXI_NO_"),
        dataIndex: "vehicleNo",
        style: { fontSize: "12px" },
      },
      {
        key: "19",
        title: context.translate("_CUSTOMER_NAME_"),
        dataIndex: "customerName",
      },

      {
        key: "2",
        title: context.translate("_CUSTOMER_NO_"),
        dataIndex: "customerContactNo",
        style: { fontSize: "12px" },
      },

      {
        key: "5",
        title: context.translate("_PICKUP_ADDRESS_"),
        dataIndex: "pickupAddress",
      },
      {
        key: "6",
        title: context.translate("_DROPOFF_ADDRESS_"),
        dataIndex: "dropAddress",
        finalWidth: 70,
      },
      {
        key: "7",
        title: context.translate("_ESTIMATED_FARE_"),
        dataIndex: "estimateFare",
        finalWidth: 70,
      },
      {
        key: "8",
        title: context.translate("_TOTAL_FARE_"),
        dataIndex: "totalFare",
        style: { fontSize: "12px" },
        finalWidth: 100,
      },
      {
        key: "9",
        title: context.translate("_BOOKING_DATETIME_"),
        dataIndex: "bookingDateTime",
        style: { fontSize: "12px" },
      },
      {
        key: "10",
        title: context.translate("_TRIP_START_TIME_"),
        dataIndex: "tripStartTime",
        style: { fontSize: "12px" },
        // render: (value) => {
        //   if (value) {
        //     const formattedDate = dayjs(value).format("DD-MM-YYYY");
        //     return <>{formattedDate}</>;
        //   } else {
        //     return <></>;
        //   }
        // },
      },
      {
        key: "10",
        title: context.translate("_TRIP_STOP_TIME_"),
        dataIndex: "tripEndTime",
        style: { fontSize: "12px" },
        // render: (value) => {
        //   if (value) {
        //     const formattedDate = dayjs(value).format("DD-MM-YYYY");
        //     return <>{formattedDate}</>;
        //   } else {
        //     return <></>;
        //   }
        // },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status",
        width: "7%",
        render: (mainValue, record) => {
          const status = Number(mainValue);
          const isAdvancedBooking = Number(record?.isAdvancedBooking) === 1;

          const statusMap = {
            1: isAdvancedBooking
              ? {
                text: this.context.translate("_ADVANCE_BOOKING_"),
                bg: "#b0ebfb",
                color: "#267e95",
              }
              : {
                text: this.context.translate("_FINDING_"),
                bg: "#eae6fe",
                color: "#665aa7",
              },

            2: {
              text: this.context.translate("_IN_PROGRESS_"),
              bg: "#b1ecfc",
              color: "#1b758f",
            },

            3: {
              text: this.context.translate("_BOOKING_FAILED_"),
              bg: "#fcdfde",
              color: "#e20500",
            },

            4: {
              text: this.context.translate("_ONGOING_"),
              bg: "#fdf2b4",
              color: "#ff8b00",
            },

            5: {
              text: this.context.translate("_FINISHED_"),
              bg: "#ffedf3",
              color: "#ff1f6b",
            },

            6: {
              text: this.context.translate("_BOOKED_"),
              bg: "#abf5d2",
              color: "#016646",
            },

            7: {
              text: this.context.translate("_CANCELLED_"),
              bg: "#edeef2",
              color: "#7e8b9b",
            },
          };

          const cfg = statusMap[status];
          if (!cfg) return null;

          return (
            <Tag
              style={{
                backgroundColor: cfg.bg,
                color: cfg.color,
                textAlign: "center",
                minWidth: "80px",
              }}
            >
              {cfg.text}
            </Tag>
          );
        }
        // render: (mainValue) => {
        //   let value = Number(mainValue);

        //   if (value === 1) {
        //     return (
        //       <Tag
        //         style={{ width: "56px", textAlign: "center" }}
        //         color={config.deleteColor}
        //       >
        //         {this.context.translate("_FINDING_")}
        //       </Tag>
        //     );
        //   } else if (value === 2) {
        //     return (
        //       <Tag
        //         style={{ width: "87px", textAlign: "center" }}
        //         color={config.ExpirySoonColor}
        //       >
        //         {this.context.translate("_BOOKING_PROCESSING_")}
        //       </Tag>
        //     );
        //   } else if (value === 3) {
        //     return (
        //       <Tag
        //         style={{ width: "56px", textAlign: "center" }}
        //         color={config.activeColor}
        //       >
        //         {this.context.translate("_REJECTED_")}
        //       </Tag>
        //     );
        //   } else if (value === 4) {
        //     return (
        //       <Tag
        //         style={{ width: "56px", textAlign: "center" }}
        //         color={config.inActiveColor}
        //       >
        //         {this.context.translate("_ONGOING_")}
        //       </Tag>
        //     );
        //   } else if (value === 5) {
        //     return (
        //       <Tag
        //         style={{ width: "56px", textAlign: "center" }}
        //         color={config.inActiveColor}
        //       >
        //         {this.context.translate("_FINISHED_")}
        //       </Tag>
        //     );
        //   } else if (value === 6) {
        //     return (
        //       <Tag
        //         style={{ width: "56px", textAlign: "center" }}
        //         color={config.inActiveColor}
        //       >
        //         {this.context.translate("_BOOKED_")}
        //       </Tag>
        //     );
        //   } else if (value === 7) {
        //     return (
        //       <Tag
        //         style={{ width: "56px", textAlign: "center" }}
        //         color={config.inActiveColor}
        //       >
        //         {this.context.translate("_CANCELLED_")}
        //       </Tag>
        //     );
        //   }
        // },
      },
      {
        title: context.translate("_CANCEL_BOOKING_"),
        dataIndex: "status",
        width: "4%",
        align: "center",
        render: (status, record) => {
          if (Number(status) !== 6) return null;

          return (
            <Tooltip title={this.context.translate("_CANCEL_BOOKING_")}>
              <CloseCircleOutlined
                style={{
                  color: "#ff4d4f",
                  fontSize: 18,
                  cursor: "pointer",
                }}
                onClick={() => this.handleCancelBooking(record)}
              />
            </Tooltip>
          );
        },
      }
    ];

    //check which user-------
    let column = this.selectedCol;
    if (this.user === -1 || this.user === 3) {
      column = this.selectedCol;
    } else {
      column = this.selectedCol?.filter((val) => val.dataIndex !== "Action");
    }
    this.selectedCol = column;
    // ------------------------------

    let hideColumns = this.selectedCol;
    if (
      config.project === "awtltrack" ||
      config.project === "starlingeye" ||
      config.project === "trackeazy"
    ) {
      hideColumns = this.selectedCol?.filter(
        (val) => val.dataIndex !== "trackerId"
      );
    }
    this.selectedCol = hideColumns;

    this.state = {
      status: 0,
      loading: false,
      pageSize: 50,
      currentPage: 1,

      loadData: 0,

      companyVal_Lab: { value: "-1", label: "All" },
      companyId: "",
      status: -1,

      selectedColumns: widthAdderFunc(this.selectedCol),
      openBookingForm: false,
      searchField: "",
      // position:[]
    };

    // this.formRef = React.createRef();
  }
  handleCancelBooking = async (record) => {
    Modal.confirm({
      title: this.context.translate("_CONFIRM_CANCEL_BOOKING_"),
      content: this.context.translate(
        "_ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_BOOKING_"
      ),
      okText: this.context.translate("_YES_"),
      cancelText: this.context.translate("_NO_"),
      okType: "danger",
      onOk: () => {
        // Call your cancel booking API
        console.log("Cancel booking:", record);
        // this.bookingStore.cancelBooking(record.bookingRequestId)
        // confirmBooking

        const postData = {};
        postData.bookingId = record.bookingRequestId;
        // postData.notificationId = this.state.bookingData?.notificationId;
        postData.status = 7;

        const resp = this.cancelBooking(postData);
        this.setState({ showBookingModal: false, bookingData: null });
        console.log("Cancel booking:", record, resp);
        if (resp?.success == 'S') {
          message.success(resp.data.message);
          // this.handleSearch();
        }

        this.handleSearch();






      },
    });
  };
  async cancelBooking(postData) {
    const resp = await this.bookingStore.cancelBooking(postData);
    return resp;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setVehicleStates = this.context.viewStateStore.vehicleDetailsObject;
      console.log(setVehicleStates);
      if (setVehicleStates.companyId !== "") {
        await this.vehicleStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setVehicleStates.companyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,

          usercompanyId: this.props.getUserData().userCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setVehicleStates.companyId
        );

        await this.setState({ loadList: 1 });
        await this.setState({ companyVal_Lab: singleData });
      }
      this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        excelCompanyId: this.props.getUserData().userCompanyId,
      });

      //  console.log(this.state.companyId)
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    } else {
      await this.handleSearch();
    }

    await this.setState({ column: this.state.selectedColumns });

    this.setState({ pageSize: 50 });
  }
  async handleChange(comp) {
    if (comp) {
      await this.setState({
        companyId: comp.value,
        currentPage: 1,
        pageSize: 50,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        comp.value,
        1
      );
      console.log(singleData, comp.value);
      await this.setState({
        companyVal_Lab: singleData,
        companyId: comp.value,
      });
      await this.handleSearch();
    } else {
      console.log("innn");
      await this.setState({
        companyId: null,
        companyVal_Lab: null,
      });
      this.vehicleStore.vehicles = [];
      this.vehicleStore.total = 0;
      this.setState({ loadData: 1 });
    }
  }

  async handleSearch() {
    await this.bookingStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      status: this.state.status,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      searchField: this.state.searchField,
    });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  onEdit = async (record) => {
    const vehicleId = record.vehicleId;
    if (vehicleId) {
      this.context.viewStateStore.setVehicleStates({
        companyId: record.companyId,
      });
      await this.setState({ vehicleIdForEdit: vehicleId });
      if (this.props.getUserData().userType == 9) {
        await this.setState({ openVehicleSecureTrackAddForm: true });
      } else {
        await this.setState({ openVehicleAddForm: true });
      }
    }
  };

  searchInput = async (e) => {
    const value = e.target.value;
    // await this.setState({searchField:value})
    if (value.length >= 3) {
     // this.handleSearch();
      //await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      this.handleSearch();
    }
  };

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      console.log(resp.data.message);
      // this.props.navigate("/vehiclelist");
      console.log(this.state.listDataUpdate);
      await this.setState({ listDataUpdate: true });
      this.setState({
        openVehicleAddForm: false,
        openCertificateForm: false,
        openVehicleSecureTrackAddForm: false,
      });
    } else if (resp.data.success == "F0") {
      if (resp.data.errors[0]?.full_imei) {
        message.error(this.context.translate(resp.data.errors[0]?.full_imei));
      }
    } else {
      message.error(this.context.translate(resp.data.message));
    }
  };

  confirmStatus = async (status) => {
    const data = {};

    data.vehicleId = this.state.vehicleId;
    data.activeStatus = this.state.isActive === true ? 1 : 0;

    await this.bookingStore.updateStatus(data);

    console.log(data);

    this.setState({ showStatusConfirm: false });
    await this.handleSearch();
  };

  closeModal = () => {
    this.setState({
      openBookingForm: false,
    });
  };

  async searchInputButton() {
    this.handleSearch();
  }
  refreshList = async () => {
    this.setState({ loading: true });
    await this.handleSearch();
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_BOOKING_DASHBOARD_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                
                {(Number(this.props.getUserData().isadmin) === -1 ||
                  Number(this.props.getUserData().isadmin) === 3 ||
                  (this.props.getUserData().userName === "Kiosk" &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Tooltip
                    // title="Add"
                    title={this.context.translate("_NEW_BOOKING_")}
                    placement="left"
                    color={config.primaryColor}
                  >
                    <Button
                      className="addButton"
                      icon={<PlusOutlined />}
                      type="primary"
                      onClick={() =>
                        this.setState({
                          openDriverDetailsForm: true,
                          vehicleIdForEdit: "",
                        })
                      }
                    ></Button>
                  </Tooltip>
                )}
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  showAll={1}
                  allowClear={true}
                  onChange={(value) => this.handleChange(value)}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  style={companyInputBox}
                />

                <Select
                  className="searchInput"
                  style={{ width: 150 }}
                  onSelect={async (value) => {
                    await this.setState({ status: value });
                    this.handleSearch();
                  }}
                  value={this.state.status}
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"
                  )}
                >
                  <Select.Option value={-1}>
                    {this.context.translate("_ALL_")}
                  </Select.Option>
                  <Select.Option value={1}>
                    {this.context.translate("_FINDING_")}
                  </Select.Option>
                  <Select.Option value={2}>
                    {this.context.translate("_BOOKING_PROCESSING_")}
                  </Select.Option>
                  <Select.Option value={3}>
                    {this.context.translate("_REJECTED_")}
                  </Select.Option>
                  <Select.Option value={4}>
                    {this.context.translate("_ONGOING_")}
                  </Select.Option>
                  <Select.Option value={5}>
                    {this.context.translate("_FINISHED_")}
                  </Select.Option>
                  <Select.Option value={6}>
                    {this.context.translate("_BOOKED_")}
                  </Select.Option>
                  <Select.Option value={7}>
                    {this.context.translate("_CANCELLED_")}
                  </Select.Option>
                </Select>
                <Input
                  className="searchInput"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_CUSTOMERNAME_"
                  )}
                  value={this.state.searchField ? this.state.searchField : ""}
                  style={{
                    width: 200,
                    borderRadius: "25px",
                  }}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                    this.searchInput(e);
                  }}
                // allowClear
                />
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                    }}
                  ></Image>
                </Tooltip>

                {/* <Dropdown
                  overlayClassName="export-dropdown"
                  menu={this.waslMenuList}
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      marginInlineEnd: "20px",
                    }}
                    src={kebabIcon}
                  ></Image>
                </Dropdown> */}

                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({
                      openBookingForm: true,
                      vehicleIdForEdit: "",
                    })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            // rowSelection={{
            //   // columnWidth: 2,
            //   fixed: true,

            //   selectedRowKeys: this.state.selectedVehicle,
            //   onChange: async (selectedRowKeys, selectedRows) => {
            //     await this.setState({ selectedVehicle: selectedRowKeys });
            //     await this.setState({ full_imei: selectedRows });
            //   },
            // }}
            // rowKey="vehicleId"
            currentPage={this.state.currentPage}
            total={this.bookingStore?.total}
            pageSize={this.state.pageSize}
            columns={this.state.column}
            dataSource={this.bookingStore?.bookingData}
            loading={this.bookingStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openBookingForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openBookingForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            title={
              <div className="formTitle">
                {this.context.translate("_BOOKING_")}
                <p className="formDescription">
                  {this.context.translate("_BOOKING_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ openBookingForm: false })}
            onCancel={() =>
              this.setState({ openBookingForm: false, openBookingForm: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <BookingAdd
                bookingRequestId={this.state.bookingRequestId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
          // </Modal>
        )}
      </>
    );
  }
}
BookingList.contextType = StoreContext;
export default observer(withRouter(BookingList));
